<template>
  <div class="content-item flex">
    <div class="content-item-label"><span class="red" v-if="JSON.parse(commonData[0].value)==='1'">*</span>疫苗分类</div>
    <el-checkbox-group v-model="checkList" @change="$emit('checkoutVaccineLabel', checkList)">
      <el-checkbox v-for="(item, index) in checkoutList" :label="item.code" :key="index">{{item.desc}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import {request} from "@/utils/axios";
export default {
  name: "CheckBoxClass",
  props: ['functionIds', 'commonData'],
  data() {
    return {
      checkoutList: [],
      checkList: [],
      index: '',
    }
  },
  created() {
    this.queryVaccineCategories();
  },
  methods: {
    setCheckList (data) {
      this.checkList = data;
    },
    queryVaccineCategories() {
      return new Promise((resolve,reject) => {
        if (this.checkoutList.length == 0) {
          request(this.functionIds.queryVaccineCategories,{
            tenantId: this.$commonJs.getTenantId()
          }).then(res => {
            this.checkoutList = res || [];
            resolve(this.checkoutList);
          }).catch(err => {
            reject(err)
          })
        } else {
          resolve(this.checkoutList)
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
